import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useApi from "../utils/useApi";

const Notification = ({ recentnotifications }) => {
    const { callApi } = useApi();
    const navigate = useNavigate(); // To navigate after API call
    const handleNotificationClick = async (item) => {
        try{
            console.log("Notification ID...", item);
            // const params = {
            //     notification_id: item._id
            // };
            await callApi({ endpoint: "/client/notifications-mark",
                 method: "POST",
                 data: { notification_id: item._id } });
            // Once the notification is marked as read, redirect to the folder details page
           await navigate(`/folder-details/${item?.parent_directory_id}`);
        }catch (error) {
            console.error("Failed to mark notification as read:", error);
        }
    }
    return (
        <div className="col-xl-6">
            <div className="global_cardbox">
                <div className="global_card_header">
                    <div className="global_head_tag">
                        <span>
                            <i className="fa-solid fa-file"></i>
                        </span>
                        Recent Notifications
                    </div>
                </div>
                <div className="card_body">
                    <p>These are the Recent notifications visible to you.</p>
                    <div className="recent_file_area">
                        <ul className="recent_file_item_list">
                            {/* ✅ Generate `cnt` number of list items dynamically */}
                            {recentnotifications.length > 0 ? (
                                recentnotifications.map((item) => (
                                    <li key={item.parent_directory_id}>
                                        <button className="notification-btn"
                                        onClick={()=>handleNotificationClick(item)}>
                                            <span className="recent_file_item_icon">
                                                <i className="fas fa-folder-open"></i>
                                            </span>
                                            <span className="notification_file_item_filename">
                                                <h6>{item.parent_directory_name}</h6>
                                                <em>{item?.message}</em>
                                            </span>
                                        </button>
                                        {/* <Link to={`/folder-details/${item.parent_directory_id}`}>
                                            <span className="recent_file_item_icon">
                                                <i className="fas fa-folder-open"></i>
                                            </span>
                                            <span className="recent_file_item_filename">
                                                <h6>{item.parent_directory_name}</h6>
                                                <em>{item?.message}</em>
                                            </span>
                                        </Link> */}
                                    </li>
                                ))
                            ) : (
                                <ul className="recent_file_item_list">
                                    <li>
                                        No Folders Found
                                    </li>
                                </ul>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Notification;
